import type { FailedEntry } from '@assist/offline';
import { useEffect, useState } from 'preact/hooks';
import { app } from '../controller.js';
import { t } from '../i18n.js';

export function Failed() {
  const [rows, setRows] = useState<FailedEntry[]>([]);
  useEffect(() => {
    void app.session?.failedEntries().then(setRows);
  }, []);
  return (
    <section>
      <div class="card">
        <h3>{t.failedTitle}</h3>
        <p class="muted">{t.failedHelp}</p>
        <ul class="list">
          {rows.map((r) => (
            <li key={r.opId}>
              <div>
                <strong>{r.key.split('/')[0]}</strong>{' '}
                <span class="muted">{new Date(r.at).toLocaleString()}</span>
                <div class="err">{r.error}</div>
              </div>
            </li>
          ))}
        </ul>
      </div>
    </section>
  );
}
